import {Component, WritableSignal, signal, inject, Signal} from '@angular/core';
import {EagleILayer} from '../../classes/eagle-i-layer';
import {LeafletVectortileSource} from '../../classes/leaflet-vectortile-source';
import {MapService} from '../../../map/services/map.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {LeafletLegendService} from '../../services/leaflet-legend.service';

@Component({
    selector: 'eaglei-leaflet-vectortile-layer',
    templateUrl: './leaflet-vectortile-layer.component.html',
    styleUrls: ['./leaflet-vectortile-layer.component.scss'],
    standalone: false,
})
export class LeafletVectortileLayerComponent extends EagleILayer<LeafletVectortileSource> {
    private mapService = inject(MapService);
    private legendService = inject(LeafletLegendService);
    protected minZoom: WritableSignal<number> = signal(undefined);
    protected zoomLevel: Signal<number> = toSignal(this.mapService.currentZoomLevel, {initialValue: 0});

    constructor() {
        super();
    }

    afterViewInit(): void {}

    toggleLayer(activeState: boolean): void {
        if (this.minZoom() === undefined && this.mapLayer.getParams()?.map?.minZoom) {
            this.minZoom.update(() => {
                return this.mapLayer.getParams().map.minZoom;
            });
        }

        if (activeState) {
            if (!this.layerSource) {
                if (this.mapLayer.legend) {
                    this.legendService.getLegend(this).subscribe((legend) => (this.legend = legend));
                }

                this.layerSource = new LeafletVectortileSource(this.mapLayer);
            }

            this.layerSource.fetchTiles();
            this.layerSource.addToMap();
        } else {
            this.layerSource.removeFromMap();
        }
    }

    protected fitToMinZoom() {
        this.layerSource.mapRef.zoomIn(this.minZoom() - this.zoomLevel());
    }
}
